import { MetaVars } from "../lib/helpers"

const setupStripe = () => {
  if (!MetaVars.stripeKey) return // no Stripe key on page
  if (window.stripe) return // already loaded Stripe
  if (!window.Stripe) return // stripe library isn't loaded yet

  // Stripe requires HTTPS in production. Skip initialization if not on HTTPS
  // to avoid IntegrationError from bots/crawlers loading JS on arbitrary pages.
  // See: https://stripe.com/docs/security/guide#tls
  if (window.location.protocol !== "https:" && MetaVars.envProduction) return

  window.stripe = Stripe(MetaVars.stripeKey)
}
document.addEventListener("DOMContentLoaded", setupStripe)